import React from "react";
import styles from "../styles/card3.module.css";

export default function Card3() {
    return (
        <div className={styles['feature-card']}>
            <div className={styles['feature-content']}>
                <div className={styles['feature-content1']}>
                    <h3>Maximize Seat Confirmation</h3>
                    <p>
                        Double your chances of confirmed seat with our AI-powered route planner.
                    </p>
                </div>
            </div>
            <div className={styles['feature-image']}>
                <img src="/background5.svg" alt="AI Assistant Illustration" />
            </div>
        </div>
    );
}
